import { render, staticRenderFns } from "./card-compare-yuri.vue?vue&type=template&id=5d159cd8&scoped=true&"
import script from "./card-compare-yuri.vue?vue&type=script&lang=js&"
export * from "./card-compare-yuri.vue?vue&type=script&lang=js&"
import style0 from "./card-compare-yuri.vue?vue&type=style&index=0&id=5d159cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d159cd8",
  null
  
)

export default component.exports